import React from 'react';
import { IconProps } from '../ui/Icon/types';
import Icon from '../ui/Icon';

export default function IconMenuToggle(props: IconProps) {
  return (
    <Icon {...props} viewBox="0 0 25 18" fill="none">
      <path
        fill="currentColor"
        d="M0 1.28C0 .571.557 0 1.244 0h10.012c.33 0 .646.135.88.375.233.24.364.565.364.904 0 .34-.131.665-.364.905-.233.24-.55.375-.88.375H1.244c-.33 0-.646-.135-.88-.375A1.298 1.298 0 0 1 0 1.279ZM0 9c0-.707.557-1.28 1.244-1.28h22.512c.33 0 .646.136.88.375.233.24.364.566.364.905 0 .34-.131.665-.364.905-.233.24-.55.374-.88.374H1.244c-.33 0-.646-.134-.88-.374A1.298 1.298 0 0 1 0 9Zm1.244 6.441c-.33 0-.646.135-.88.375-.233.24-.364.565-.364.905 0 .339.131.664.364.904.234.24.55.375.88.375h15.012c.33 0 .646-.135.88-.375.233-.24.364-.565.364-.904 0-.34-.131-.665-.364-.905a1.226 1.226 0 0 0-.88-.375H1.244Z"
      />
      <path
        fill="currentColor"
        d="M0 1.28C0 .571.557 0 1.244 0h10.012c.33 0 .646.135.88.375.233.24.364.565.364.904 0 .34-.131.665-.364.905-.233.24-.55.375-.88.375H1.244c-.33 0-.646-.135-.88-.375A1.298 1.298 0 0 1 0 1.279ZM0 9c0-.707.557-1.28 1.244-1.28h22.512c.33 0 .646.136.88.375.233.24.364.566.364.905 0 .34-.131.665-.364.905-.233.24-.55.374-.88.374H1.244c-.33 0-.646-.134-.88-.374A1.298 1.298 0 0 1 0 9Zm1.244 6.441c-.33 0-.646.135-.88.375-.233.24-.364.565-.364.905 0 .339.131.664.364.904.234.24.55.375.88.375h15.012c.33 0 .646-.135.88-.375.233-.24.364-.565.364-.904 0-.34-.131-.665-.364-.905a1.226 1.226 0 0 0-.88-.375H1.244Z"
      />
    </Icon>
  );
}
